





























import Vue from 'vue';
import ContainItemEditor from './ContainItemEditor.vue';

export default Vue.extend({
  components: {
    ContainItemEditor,
  },
  computed: {
    hasValue(): boolean {
      return this.custom.keywords && this.custom.keywords.length;
    },
  },
  props: {
    custom: Object,
  },
  data() {
    return {
      showValuesPanel: false,
    };
  },
  methods: {
    updateNotIn(value: number) {
      this.$emit('updateNotIn', value === 1);
    },
    updateKeywords(items: string[]) {
      this.$emit('updateKeywords', items);
      this.showValuesPanel = false;
    },
  },
});
